import { Message } from './Message';
import { Suppress } from './Suppress';

export const ErrorBoundaryFallback = {
  Message,
  Suppress,
};
